export default __webpack_public_path__ + "static/media/edit-report.c46e2108.png";